import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import restaurants from './modules/restaurants'
import restauranttypes from './modules/restauranttypes'
import openingtimes from './modules/openingtimes'
import categories from './modules/categories'
import items from './modules/items'
import menus from './modules/menus'
import menuitems from './modules/menuitems'
import itemssearch from './modules/itemssearch'
import orderscontrol from './modules/orderscontrol'
import ordersbyphonecontrol from './modules/ordersbyphonecontrol'
import ordermessages from './modules/ordermessages'
import orders from './modules/orders'
import taxes from './modules/taxes'
import printer from './modules/printer'
import paymentsubscription from './modules/paymentsubscription'
import loading from './modules/loading'
import currentwaitingtime from './modules/currentwaitingtime'
import receipts from './modules/receipts'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    login,
    restaurants,
    restauranttypes,
    openingtimes,
    categories,
    items,
    menus, 
    menuitems,
    itemssearch,
    orderscontrol,
    ordersbyphonecontrol,
    orders,
    taxes,
    printer,
    ordermessages,
    loading,
    paymentsubscription,
    currentwaitingtime,
    receipts
  },
  strict: debug
})